import { Box, Button } from "@mui/material";
import ReplayIcon from '@mui/icons-material/Replay';

const FormReset = ({ updateValue }: { updateValue: (value: string) => void }) => {
    const toggleForm = () => {
        updateValue("true")
    }
    return <Box       
        sx={{m: 1, mr:'25px'}}>
        <h3>Thanks for getting in touch! We'll get back to you ASAP.</h3>
        <Button 
        variant='contained'
        type="submit" 
        color='primary'
        onClick={toggleForm}
        className='right'
        >
        <ReplayIcon/>
        </Button>
      </Box>
  }

  export default FormReset;